export default {"src":"/_next/static/media/schedule-events-icon.f37b07b6.svg","height":125,"width":140,"blurWidth":0,"blurHeight":0};